/**
 * Constant values for Markdown Parser
 */
/**
 * List plugin events
 *
 * @hidden
 */
export const LISTS_COMMAND = 'lists-commands';
/**
 * selectioncommand plugin events
 *
 * @hidden
 */
export const selectionCommand = 'command-type';
/**
 * Link plugin events
 *
 * @hidden
 */
export const LINK_COMMAND = 'link-commands';
/**
 * Clear plugin events
 *
 * @hidden
 */
export const CLEAR_COMMAND = 'clear-commands';
/**
 * Table plugin events
 *
 * @hidden
 */
export const MD_TABLE = 'insert-table';
/**
 * insertText plugin events
 *
 * @hidden
 */
export const INSERT_TEXT_COMMAND = 'insert-text';
